namespace RedBullMOBILE360.ESim {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.ESim.EsimActivationCodeGrid')
    export class EsimActivationCodeGrid extends Serenity.EntityGrid<EsimActivationCodeRow, any> {
        protected getColumnsKey() { return EsimActivationCodeColumns.columnsKey; }
        protected getDialogType() { return EsimActivationCodeDialog; }
        protected getIdProperty() { return EsimActivationCodeRow.idProperty; }
        protected getInsertPermission() { return EsimActivationCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return EsimActivationCodeRow.localTextPrefix; }
        protected getService() { return EsimActivationCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Import From Excel',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new ESIMExcelImportDialog();
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }

    }
}